const homeContentType = {
    all: 0,
    station: 1,
    podcast: 2,
};

export default homeContentType;
